// Step 5d (2026-11-03; Ahmed's answer 9a, mockup Ro3jT69D7UncSpAvAJV2be, screen "The flag on the PO"): a PO whose invoice number is also on another PO of the
// vendor, confirmed as "a different receipt", carries a "Repeated invoice number" tag and a note on its page. The CEO or finance marks it seen; the flag stays.
import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Tag, message } from 'antd';
import dayjs from 'dayjs';
import { getPoFlags, markFlagSeen, PoFlag } from '../../api';
import { money } from '../receiving/shared';

export function usePoFlags(poId: string | null | undefined, refreshKey?: number) {
  const [flags, setFlags] = useState<PoFlag[]>([]);
  const load = useCallback(() => { if (poId) getPoFlags(poId).then(setFlags).catch(() => setFlags([])); else setFlags([]); }, [poId]);
  useEffect(() => { load(); }, [load, refreshKey]);
  return { flags, reload: load };
}

export const RepeatTag: React.FC<{ flags: PoFlag[] }> = ({ flags }) =>
  (flags.some((f) => f.kind === 'repeated_invoice') ? <Tag color="gold" style={{ fontSize: 13, padding: '2px 10px' }}>Repeated invoice number</Tag> : null);

export const RepeatNotes: React.FC<{ flags: PoFlag[]; canSee: boolean; onSeen: () => void }> = ({ flags, canSee, onSeen }) => (
  <>
    {flags.filter((f) => f.kind === 'repeated_invoice').map((f) => (
      <Alert key={f.id} type={f.seen ? 'info' : 'warning'} showIcon style={{ marginBottom: 16 }} message={(
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <span><b>Invoice {f.number || '(no number)'} is also on {f.other?.poId || 'another PO'}</b>{f.other ? ` (${dayjs(f.other.date).format('D MMM')}, EGP ${money(f.other.total)})` : ''}. {f.by || 'The officer'} chose "a different receipt" on {dayjs(f.at).format('D MMM')}.</span>
          <span style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ fontSize: 12.5 }}>{f.seen ? `Seen by ${f.seen.by || 'the CEO or finance'} on ${dayjs(f.seen.at).format('D MMM')}.` : 'Not seen yet by the CEO or finance.'}</span>
            <span style={{ display: 'flex', gap: 6 }}>
              {f.other?.poId && <Link to={`/pos/${f.other.poId}`}><Button size="small">Open {f.other.poId}</Button></Link>}
              {!f.seen && canSee && <Button size="small" type="primary" onClick={async () => { try { await markFlagSeen(f.id); onSeen(); } catch (e: any) { message.error(e?.response?.data?.error || 'Could not mark it seen'); } }}>Seen</Button>}
            </span>
          </span>
        </div>
      )} />
    ))}
  </>
);
